import Axios, * as others from 'axios';
import URL from '../../Environment';
import IMGPATHS from '../../ImgPaths';
import React, { Component,useEffect, useState } from "react";
import './activity.css';
import { format } from "date-fns";
import { useParams } from "react-router-dom";
import { Link } from 'react-router-dom';
// import GLightbox from 'glightbox';
// import 'glightbox/dist/css/glightbox.min.css';

const ActivityDetail = () => {
  const { id } = useParams();
  const [ActivityData, setActivityData] = useState([]);
  const [ActivityLoan, setActivityLoading] = useState(true);
  const [errorActivity, setActivityError] = useState(null);
  const [ActivityDetailData, setActivityDetailData] = useState([]);
  const [ActivityDetailLoan, setActivityDetailLoading] = useState(true);
  const [errorActivityDetail, setActivityDetailError] = useState(null);

  //console.log(id);

  useEffect(() => {

    // const lightbox = GLightbox({
    //   selector: ".glightbox",
    //   touchNavigation: true,
    //   loop: true,
    //   closeButton: true,
    //   autoplayVideos: true,
    // });

    const fetchActivityData = async () => {

          Axios.get(URL + `api/Activity/GetActivityDetails?id=${id}`).then((response) => {
            const res = response.data;
            //console.log(res);
    
            setActivityData(response.data);
            setActivityLoading(false);   
    
          }).catch((error) => {
            setActivityError(error);
            setActivityLoading(false); 
    
          });
    };
    
    const fetchActivityImageData = async () => {

      try {
        const response = await Axios.post(URL + 'api/Activity/GetActivityDetailsImage', {
          id: id,
        });
  
        //console.log(response);
        setActivityDetailData(response.data);
        setActivityDetailLoading(false); 

      } catch (err) {
        console.log(err);
        setActivityDetailError(error);
        setActivityDetailLoading(false); 

      }

      // Axios.get(URL + `api/Activity/GetActivityDetailsImage?id=${id}`).then((response) => {
      //   const res = response.data;
      //   console.log(res);

      //   setActivityDetailData(response.data);
      //   setActivityDetailLoading(false);   

      // }).catch((error) => {
      //   setActivityDetailError(error);
      //   setActivityDetailLoading(false); 

      // });
  };

    // เรียกใช้งาน fetchData เมื่อค่าตัวแปร count มีการเปลี่ยนแปลง
    fetchActivityData();
    fetchActivityImageData();


    // Cleanup function ที่จะถูกเรียกเมื่อ component ถูก unmount
    return () => {
      // ทำการคืนการทำงานที่ต้องการ (cleanup)
      //lightbox.destroy();
      //console.log('Component unmounted');
    };



  }, []);

  if (ActivityLoan) {
      return <div>Loading...</div>;
  }

  if (errorActivity) {
      return <div>Error: {errorActivity.message}</div>;
  }

  if (ActivityDetailLoan) {
    return <div>Loading...</div>;
  }

  if (errorActivityDetail) {
      return <div>Error: {errorActivityDetail.message}</div>;
  }

  return (
    <div>
      <section className="breadcrumbs">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
              <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
              <i className="fa fa-angle-right" />&nbsp;<a href="activity" className="a-breadcrumbs">ข่าวกิจกรรม</a>
            </div>
          </div>
        </div>
      </section>

      <div className="col-lg-12">
          <section id="blog-details" className="blog-details section">
          <div className="container section-title">
            <h2>ข่าวกิจกรรม</h2>
          </div>
            <div className="container">
              <article className="article">
                
                {
                  ActivityData.map((act) => (
                  
                  <div key={act.id}>
                    <div className="post-img">
                      <img src={`${IMGPATHS}` + `Img/Activity/${act.id}/${act.img}`} alt className="img-fluid" 
                      style={{
                        height: '900px',
                        width: 'auto',
                        objectFit: 'contain' // หรือ 'cover' ขึ้นอยู่กับผลลัพธ์ที่ต้องการ
                      }} />
                    </div>
                      <h2 key={act.id} className="title">{act.topic}</h2>
                    {/* <div className="meta-top">
                      <ul>
                        <li className="d-flex align-items-center"><i className="bi bi-person" /> <a href="#" style={{fontSize:'20px'}}>{act.update_by}</a></li>
                        <li className="d-flex align-items-center"><i className="bi bi-clock" /> <a href="#" style={{fontSize:'20px'}}>{format(new Date(act.update_day), "d MMMM, yyyy")}</a></li>
                      </ul>
                    </div> */}
                    <div className="content">
                      <p style={{fontSize:'20px'}}>
                        {/* {act.description} */}
                        <div 
                          className="loan-detail-content"
                          style={{fontSize:'20px', whiteSpace: 'pre-wrap'}}
                          dangerouslySetInnerHTML={{ __html: act.description }}
                        />
                      </p>
                    </div>
                  </div>
                  ))
                }

              </article>
            </div>
          </section>

          <section id="services" className="services section">
            <div className="container" >
              <div className="row gy-5">

              {
                ActivityDetailData.map((act) => (
                  <div key={act.id} className="col-xl-4 col-md-6">
                    <div className="service-item">
                      <div className="img">
                        <img src={`${IMGPATHS}` + `Img/Activity/${act.activity_id}/${act.img_name}`} className="img-fluid" alt={act.img_desc} />
                        <div className="portfolio-info">
                              <a href={`/Img/Activity/${act.activity_id}/${act.img_name}`} data-gallery="portfolio-gallery-app" className="glightbox preview-link"><i className="bi bi-zoom-in" /></a>
                              {/* <a href="portfolio-details.html" title="More Details" className="details-link"><i className="bi bi-link-45deg" /></a> */}
                            </div>
                      </div>
                      <div className="details position-relative">
                          <a href={`${IMGPATHS}` + `Img/Activity/${act.activity_id}/${act.img_name}`} target='_blank' className="stretched-link">
                          {act.img_desc !== null && act.img_desc !== "" ? <p style={{fontSize:'20px', color:'#0ea2bd'}}>{act.img_desc}</p> : <p style={{fontSize:'20px', color:'#0ea2bd'}}>Read</p>}
                            
                          </a>
                        </div>
                      </div>
                  </div>

                  ))
                }
                    
              </div>
            </div>
          </section>

        </div>
    </div>
  );
}

export default ActivityDetail;
